import axios from 'axios'
import _ from 'lodash'
import queryString from 'query-string';

const server_url = process.env.REACT_APP_SERVER_URL

const getListLinkedAccount = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/linkedAccountDistributor/getListLinkedAccount?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const addLinkedAccount = async (token, sendData) => {
  return await axios
    .post(`${server_url}/api/distributor/linkedAccountDistributor/addLinkedAccount`, sendData, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const removeAccountFromLinked = async (token, sendData) => {
  return await axios
    .post(`${server_url}/api/distributor/linkedAccountDistributor/removeAccountFromLinked`, sendData, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

export {
  getListLinkedAccount,
  addLinkedAccount,
  removeAccountFromLinked
}